module.exports = __webpack_public_path__ + "media/images/steps/step_10-4a150ed9100e045ed71137847ce57221.svg";